import { useMemo, useState } from 'react'
import { makeChartData } from 'components/features/creditCard/creditCardComparisonChart/helpers'
import last from 'lodash/last'

const rateMap = {
  status: 0.02,
  no_crypto: 0.02,
  // wells_fargo: 0.02,
  // chase: 0.017,
  // citi: 0.016,
  // capitalone: 0.015,
}


export const useChartData = () => {

  const [{ spending, performance }, setParams] = useState({ spending: 1000, performance: 0.1 })

  const statusPoints = useMemo(() => {
    return makeChartData(spending, performance / 100, rateMap.status)
  }, [spending, performance])

  const points = useMemo(() => ({
    no_crypto: makeChartData(spending, 0, rateMap.no_crypto),
    // wells_fargo: makeChartData(spending, 0, rateMap.wells_fargo),
    // chase: makeChartData(spending, 0, rateMap.chase),
    // citi: makeChartData(spending, 0, rateMap.citi),
    // capitalone: makeChartData(spending, 0, rateMap.capitalone),
  }), [spending])

  // const [lastStatusPoints, lastNoCrypto, lastPointWellsFargo, lastPointChase, lastPointsCiti, lastPointsCapitalOne] = [
  const [lastStatusPoints, lastNoCrypto] = [
    last(statusPoints),
    last(points.no_crypto),
    // last(points.wells_fargo),
    // last(points.chase),
    // last(points.citi),
    // last(points.capitalone),
  ]

  const cardsAmount = useMemo(() => ({
    status: lastStatusPoints,
    no_crypto: lastNoCrypto,
    // wells_fargo: lastPointWellsFargo,
    // chase: lastPointChase,
    // citi: lastPointsCiti,
    // capitalone: lastPointsCapitalOne,
  }), [lastStatusPoints, lastNoCrypto])

  return {
    setParams,
    statusPoints,
    points,
    lastStatusPoints,
    cardsAmount,
  }
}
